import locationsMutations from "./mutations.js";
import locationsActions from "./actions.js";
import locationsGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      locationCallback:null,
      prevCallback:null,
      loadPageInfo:{},
      loadPathInfo:""
    };
  },
  mutations: locationsMutations,
  actions: locationsActions,
  getters: locationsGetters,
};
